module.exports = __webpack_public_path__ + "media/Rectangle_combined.e093cd28.wav";